"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PreviewVideoContainer_1 = require("./PreviewVideoContainer");
var client_logger_module_1 = require("@prezi/client-logger-module");
var gray1 = '#152235';
var templateNavigationButtons = {
    height: '48px',
    backgroundColor: gray1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
};
var previewPlayer = {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
};
var templateNavigationButton = {
    paddingTop: '2px',
    width: '210px',
    fontSize: '32px',
    backgroundColor: 'inherit',
    border: 'none',
    color: 'white',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};
var TemplatePreviewLite = /** @class */ (function (_super) {
    __extends(TemplatePreviewLite, _super);
    function TemplatePreviewLite() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            step: 0,
            initialLoading: true,
            isBuffering: false,
            isPlaying: false,
            jumpToFrame: false,
            isError: false,
            error: null,
        };
        _this.goToNext = function () {
            if (_this.state.isPlaying) {
                _this.setState({ isPlaying: false, jumpToFrame: true });
            }
            else {
                var nextStep = _this.state.step + 1;
                if (nextStep < _this.props.stepTimes.length) {
                    _this.setState({ step: nextStep, isPlaying: true, jumpToFrame: false });
                }
            }
            client_logger_module_1.WebsiteLogger.log({
                action: 'click',
                object: 'logged_element',
                trigger: 'click',
                payload: { page_location: 'template_player_lite', element_type: 'forward_button', source_url: window.location.pathname },
            });
        };
        _this.goToPrevious = function () {
            var nextStep = _this.state.step - 1;
            if (nextStep >= 0) {
                _this.setState({ step: nextStep, isPlaying: false, jumpToFrame: false });
            }
        };
        _this.goToFirst = function () {
            return _this.setState({ step: 0 });
        };
        _this.onPlayingStepFinished = function () {
            return _this.setState({ isPlaying: false });
        };
        _this.onVideoBufferChange = function (isBuffering) {
            return _this.setState({
                initialLoading: _this.state.initialLoading && isBuffering,
                isBuffering: !_this.state.initialLoading && isBuffering,
            });
        };
        _this.onVideoError = function (error) {
            return _this.setState({ initialLoading: false, isBuffering: false, isError: true, error: error });
        };
        return _this;
    }
    TemplatePreviewLite.prototype.render = function () {
        var isLastStep = this.state.step === this.props.stepTimes.length - 1;
        var isFirstStep = this.state.step === 0;
        var templateNavButtonLeftClass = 'template-navigation-button';
        if (isFirstStep) {
            templateNavButtonLeftClass += ' disabled';
        }
        var templateNavButtonRightClass = 'template-navigation-button';
        if (isLastStep || this.state.isBuffering) {
            templateNavButtonRightClass += ' disabled';
        }
        return (React.createElement("div", { style: previewPlayer },
            React.createElement(PreviewVideoContainer_1.PreviewVideoContainer, __assign({ templatePreviewUrl: this.props.templatePreviewUrl, templateThumbnailUrl: this.props.templateThumbnailUrl, stepTimes: this.props.stepTimes, step: this.state.step, jumpToFrame: this.state.jumpToFrame, onPlayingStepFinished: this.onPlayingStepFinished, onBufferChange: this.onVideoBufferChange, onError: this.onVideoError, isBlurred: isLastStep, preloadVideo: this.props.preloadPreviewVideo }, this.props.templatePreviewDimensions)),
            React.createElement("div", { style: templateNavigationButtons },
                React.createElement("button", { style: templateNavigationButton, className: templateNavButtonLeftClass, onClick: this.goToPrevious },
                    React.createElement("i", { className: 'icon-chevron-left' })),
                React.createElement("button", { style: templateNavigationButton, className: templateNavButtonRightClass, onClick: this.goToNext },
                    React.createElement("i", { className: 'icon-chevron-right' })))));
    };
    return TemplatePreviewLite;
}(React.Component));
exports.TemplatePreviewLite = TemplatePreviewLite;
//# sourceMappingURL=TemplatePreviewLite.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@prezi/template-preview-lite/dist/TemplatePreviewLite.js
// module id = 148
// module chunks = 0